import { z } from 'zod';
export const UserPreferredServices = z.array(z.number()).nullable();

export type UserPreferredServices = z.infer<typeof UserPreferredServices>;

export const GetUserPreferencesResponse = z.object({
  selectedServices: UserPreferredServices,
  showExtensionBanner: z.boolean(),
});

export type GetUserPreferencesResponse = z.infer<typeof GetUserPreferencesResponse>;

export const SetUserPreferencesRequest = z.object({
  selectedServices: z.array(z.number()).nullable().optional(),
  showExtensionBanner: z.boolean().optional(),
});

export type SetUserPreferencesRequest = z.infer<typeof SetUserPreferencesRequest>;

export const UserIDECheckinsSchema = z.object({
  lastCheckins: z.record(z.coerce.date()),
});

export type GetUserIDECheckinsResponse = z.infer<typeof UserIDECheckinsSchema>;

export const AddUserIDECheckinRequest = z.object({
  ideKey: z.string(),
});
